import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useResultJSON, useResultJSONBucketBaseURL } from './ResultJSON'; // Assuming this is your custom hook to fetch data
import { Card, CardContent, Typography, CardMedia, CardActionArea } from '@mui/material';
import { Grid, Box, IconButton } from '@mui/material';
import { MGames, isIGames } from '../model/Games';

interface FIPOKGamesProps {
	section: string;
}

export const FIPOKGames: React.FC<FIPOKGamesProps> = ({ section }) => {
	const jsonData = useResultJSON(); // Assuming this hook fetches JSON data from the backend
	const bucketBaseURL = useResultJSONBucketBaseURL();
	const navigate = useNavigate();

	const [games, setGames] = useState<MGames | null>(null);


	useEffect(() => {
		// Assuming that the "jsonData" object has been fetched using your useResultJSON hook
		// and it contains the "section" in the required format
		if (jsonData === null) {
			return;
		}

		if (isIGames(jsonData)) {
			setGames(new MGames(jsonData, bucketBaseURL));
		}
		
		/*if (Object.hasOwn(jsonData, section)
			&& Object.hasOwn(jsonData[section], "categoryName")
			&& typeof jsonData[section].categoryName == "object"
			&& Object.hasOwn(jsonData[section], "iconURL")
			&& typeof jsonData[section].iconURL == "string"
			&& Object.hasOwn(jsonData[section], "games")
			&& Array.isArray(jsonData[section].games)) {
			let gamesObj: FIPOKGamesObject = {
				categoryName: {},
				iconURL: jsonData[section].iconURL.replace(regexp, bucketBaseURL),
				games: []
			};
			for (let lC in jsonData[section].categoryName) {
				const c = jsonData[section].categoryName[lC];
				if (typeof c == "string") {
					gamesObj.categoryName[lC] = jsonData[section].categoryName[lC];
				}
			}
			for (let g of jsonData[section].games) {
				if (Object.hasOwn(g, "title")
					&& typeof g.title == "object"
					&& Object.hasOwn(g, "symbolicId")
					&& typeof g.symbolicId == "string"
					&& Object.hasOwn(g, "iconURL")
					&& typeof g.iconURL == "string"
					&& Object.hasOwn(g, "frameURL")
					&& typeof g.frameURL == "string"
				) {

					let gObj: FIPOKGameObject = {
						title: {},
						symbolicId: g.symbolicId,
						iconURL: g.iconURL.replace(regexp, bucketBaseURL),
						frameURL: g.frameURL.replace(regexp, bucketBaseURL)
					};

					
					const propList = ['description_short', 'description_long', 'tags', 'instructions_long'];
					propList.forEach(key => {
						if (!gObj.hasOwnProperty(key) && g.hasOwnProperty(key) ) {
							gObj[key] = g[key];
						  }
						
					});


					for (let lC in g.title) {
						const c = g.title[lC];
						if (typeof c == "string") {
							gObj.title[lC] = g.title[lC];
						}
					}
					gamesObj.games.push(gObj);
				}
			}
			setGames(gamesObj);
		}
			*/
	},
		[
			bucketBaseURL,
			jsonData,
			section
		]);

	const handleCardClick = (a_gameName: string) => {
		navigate(`/game/${a_gameName}`);
	};

	if (games === null || !(section in games.categories) || games.categories[section].games.length === 0) {
		// no games in this section, return empty div
		return (<div></div>)
		;}

	return (
		<div>
			<div style={{ display: 'flex', flexWrap: 'wrap', gap: '24px', padding: '16px' }}>

				<Box display="flex" alignItems="center" style={{ height: '100px' }}>
					<IconButton size="large">
						<img src={games.categories[section].iconURL} alt={games.categories[section].categoryName['hu']} style={{ width: '60px', height: '60px' }} />
					</IconButton>
					<Box mx={1} flexGrow={1} textAlign="center">
						<Typography variant="h3">{games.categories[section].categoryName['hu']}</Typography>
					</Box>
				</Box>

				<Grid container spacing={2}>
					{games.categories[section].games.map(game => (
						<Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={game.symbolicId+'_grid_item'}>
							<Card key={game.symbolicId} style={{ width: '90%', height: '100%' }} onClick={() => handleCardClick(game.symbolicId)}>
								<CardActionArea>
									<CardContent>
										<CardMedia
											component="img"
											width="50%"
											image={game.iconURL}
											alt={game.title.en}
										/>
										<Typography variant="h6" component="div" textAlign={'center'}>
											{game.title['hu']}
										</Typography>
										<Typography variant="body1" component="div" textAlign={'center'}>
											{game.description_short && game.description_short['hu']}
										</Typography>
									</CardContent>
								</CardActionArea>
							</Card>
						</Grid>
					))}

				</Grid>


			</div>

		</div>
	);
};

export default FIPOKGames;
